import { render } from "./UsersItem.vue?vue&type=template&id=5703703e&scoped=true"
import script from "./UsersItem.vue?vue&type=script&lang=js"
export * from "./UsersItem.vue?vue&type=script&lang=js"

import "./UsersItem.vue?vue&type=style&index=0&id=5703703e&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5703703e"]])

export default __exports__